import { Row, Col, Layout, Card } from 'antd';
import { Link } from 'react-router-dom';
import HeaderBar from '../../Layout/HeaderBar';
import FooterBar from '../../Layout/FooterBar';
import PasswordForm from './PasswordForm';
import DustBinderUsageReportTestForm from './DustBinderUsageReportTestForm';

const { Content } = Layout;

interface Props {}

function SensorList(_: Props) {
  return (
    <>
      <Layout>
        <HeaderBar />
        <Content style={{ margin: '50px 24px 0' }}>
          <Card title="Machine move time · debug" style={{ marginBottom: 24 }}>
            <Link to="/machine-move-time-debug">Se rå input og logs fra den nye sensor →</Link>
          </Card>
          <Row gutter={8}>
            <Col md={12}>
              <PasswordForm />
            </Col>
            <Col md={12}>
              <DustBinderUsageReportTestForm />
            </Col>
          </Row>
        </Content>
        <FooterBar />
      </Layout>
    </>
  );
}

export default SensorList;
